<template>
  <v-container class="no-margins">
    <div class="title-icon">
      <h1 class>{{ $t('ebook.elementpart') }}</h1>
      <v-btn icon :href="links.ebook.apprenticeInfo" target="_blank">
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>
    <v-list one-line class="skills">
      <v-card class="mb-4" flat v-for="(item,index) in repDetails" :key="index">
        <v-list-item :class="`skill${item.apprenticeshipSkillEstimatedLevel}`">
          <v-icon
            class="skill-level"
            color="red"
            v-if="item.apprenticeshipSkillEstimatedLevel==1"
          >$sl-ebook-lvl1</v-icon>
          <v-icon
            class="skill-level"
            color="red"
            v-else-if="item.apprenticeshipSkillEstimatedLevel==2"
          >$sl-ebook-lvl2</v-icon>
          <v-icon
            class="skill-level"
            color="red"
            v-else-if="item.apprenticeshipSkillEstimatedLevel==3"
          >$sl-ebook-lvl3</v-icon>
          <v-icon
            color="red"
            class="skill-level"
            v-else-if="item.apprenticeshipSkillEstimatedLevel==4"
          >$sl-ebook-lvl4</v-icon>
          <v-icon class="skill-level" v-else></v-icon>

          <v-list-item-content class="ml-2">
            <div class="overline regular">
              {{item.subElement.element.name}} > {{item.subElement.name}}
            </div>

            <div class="medium" v-if="get(item, 'apprenticeComment', null)">
              {{ get(item, 'apprenticeComment', '') | comment}}
            </div>
          </v-list-item-content>

          <v-btn
            class="elevation font-weight-bold"
            color="primary"
            :style="{ height: '40px' }"
            @click="editClick(item)""
          >
            {{ $t('ebook.rate-report') }}
          </v-btn>
        </v-list-item>
      </v-card>
    </v-list>

    <ActionButton
      type="application"
      actionIcon="$sl-add"
      @click="modalClick"
    >{{$t('ebook.add-elementpart')}}</ActionButton>

    <!-- <v-card class="element" @click="modalClick">
      <v-card-text class="d-flex align-center">
        <v-icon class>$sl-add</v-icon>
        <v-card-title>{{ $t('ebook.add-elementpart') }}</v-card-title>
      </v-card-text>
    </v-card>-->
    <v-dialog persistent v-model="openModal" max-width="700px" class="pa-0">
      <EbookElementModal
        :currentReport="currentReport"
        :selElement="selectedElement"
        :show="show"
        @close="modalClose"
        @added="addedElement"
        @deletedElement="deletedElement"
      ></EbookElementModal>
    </v-dialog>

    <NextButton
      class="mt-6"
      @click="next"
      :isDisabled="(repDetails.length<1) || isImitatingUser()"
    >{{ $t('ebook.summary')}}</NextButton>
    <BottomNav @clicked="goback" />
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import API from '@/services/api.js'
import EbookElementModal from '@/components/Ebook/Apprentice/EbookElementModal'
import NextButton from '@/components/Common/NextButton'
import findIndex from 'lodash/findIndex'
import ActionButton from '@/components/Common/ActionButton'
import BottomNav from '@/components/Application/BottomNav'
import get from 'lodash/get'

// @group Ebook
// Styled EbookElement component
export default {
  name: 'EbookElement',

  props: {
    //has current report
    currentReport: Object,
    //has current element
    element: Object
  },

  components: {
    BottomNav,
    NextButton,
    EbookElementModal,
    ActionButton
  },
  filters: {
    comment(val) {
      if (val && (val.length > 44)) {
        return val.substring(0, 44) + '...'
      } else return val
    }
  },

  data: () => ({
    links: require('../../../lib/external-links.json'),
    openModal: false,
    selectedElement: {},
    repDetails: [],
    show: ''
  }),

  created() {
    this.init()
  },

  watch: {
    element() {
      this.init()
    }
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isApprentice', 'isInstructor', 'isImitatingUser'])
  },

  methods: {
    get,

    init() {
      this.getReportDetailsList()
      if (this.element && this.element.id) {
        this.editClick(this.element)
      }
    },
    deletedElement(id) {
      const idx = findIndex(this.repDetails, ['id', id])
      if (idx > -1) {
        this.repDetails.splice(idx, 1)
      }

      this.openModal = false
    },
    modalClick() {
      this.show = 'addElement'
      this.openModal = true
    },
    modalClose() {
      this.openModal = false
    },
    editClick(item) {
      this.show = 'elementJudgement'
      this.selectedElement = item
      this.openModal = true
    },
    addedElement(reportDetail) {
      this.openModal = false
      this.getReportDetailsList()
    },
   /**
     * @vuese
     * Used to fetch report details list
     * @arg The arguments are integers representing book id and report id
     */
    getReportDetailsList() {
      API.listReportDetails(this.currentReport.bookId, this.currentReport.id)
        .then(response => {
          this.repDetails = response.data.reportDetails
        })
        .catch(error => {
          console.log('Error ' + error)
        })
    },
    next() {
      const params = {report: this.currentReport, goto: 'review'}
      // Fire goto review
      // @arg The argument is a object representing current report
      this.$emit('goto', params)
    },
    goback() {
      // Fire go back to 
      // @arg The argument is a object representing report
      const params = {report: this.currentReport, goto: 'instructor'}
      this.$emit('goto', params)
      this.$emit('goto', {report: this.currentReport, goto: 'instructor'})
    }
  }
}
</script>

